import { render } from "./4_hidroelectrica.vue?vue&type=template&id=c7a9cbd0&scoped=true"
import script from "./4_hidroelectrica.vue?vue&type=script&lang=js"
export * from "./4_hidroelectrica.vue?vue&type=script&lang=js"

import "./4_hidroelectrica.vue?vue&type=style&index=0&id=c7a9cbd0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a9cbd0"]])

export default __exports__